interface CustomMetric {
  name: string
  hash: string
  type: PlatformBrowserCustomMetricType
}

// To add to this list, read this README: https://github.com/github/github-ui/blob/9725ea2c2eca83dfe8ed851f8b183dfd45c71833/packages/stats/README.md

export const CUSTOM_METRIC_REGISTRY = {
  PRS_COMMENT_BOX_INP: {
    name: 'pull_requests.comment_box.inp',
    hash: '070a85f091c124d118031ed374badf58df0cd9c2902f9aa4f9e09f6fdcbb91d0',
    type: 'distribution',
  },
  PULL_REQUESTS_FILES_JS_HEAP: {
    name: 'pull_requests.files.js_heap',
    hash: '7c5d986de8ccbfd17ae58e0da85158912cf65aeb256aecf28c35ddeb794cd2d3',
    type: 'distribution',
  },
  PRS_ADD_COMMENT_BUTTON_CLICK: {
    name: 'pull_requests.add_comment_button.inp',
    hash: '872209fcee2ac679a3222260dbc7eb24c73ec3d6b41e635aaf761e61a5c26ccf',
    type: 'distribution',
  },
  PULL_REQUESTS_FILE_TREE_DIFF_FILE_CLICK: {
    name: 'pull_requests.file_tree_diff_file_click.inp',
    hash: '876809d762329dac08e4e44288005e102b33e6adebbc46e6f0a115bba2b8aa5e',
    type: 'distribution',
  },
  PULL_REQUESTS_FILE_TREE_DIFF_FILE_KEYBOARD_SELECTION: {
    name: 'pull_requests.file_tree_diff_file_keyboard_selection.inp',
    hash: '24f3088df0d2fcde21ee1c271b6c3d10a9e819afc581e7740bc6c79a3bec925a',
    type: 'distribution',
  },
  PULL_REQUESTS_DIFF_LINE_NUMBER_CLICK: {
    name: 'pull_requests.diff_line_number_click.inp',
    hash: 'df84c70a71715d434bc8784f6f9f6d53c94ed0ab9e4992aa8d4fed0f94b64ec3',
    type: 'distribution',
  },
  BROWSER_MEMORY_DIST_HEAP_USED: {
    name: 'browser.memory.dist.heap_used',
    hash: 'fdb6e6ee4c8789822429ad902990d5750938634f17838370c79e1abd14875d86',
    type: 'distribution',
  },
  BROWSER_MEMORY_DIST_HEAP_UTILIZATION: {
    name: 'browser.memory.dist.heap_utilization',
    hash: '962a4cd9cec8fd04bfe4c49e90f70725e6c3c8cbe2c23f7c96be44d9e99fe090',
    type: 'distribution',
  },
  BROWSER_MEMORY_DIST_SESSION_GROWTH: {
    name: 'browser.memory.dist.session_growth',
    hash: 'bcc4dcdd2464d0a48e1478928740dfb341ca58d509cdd87d6405e97db3518988',
    type: 'distribution',
  },
  BROWSER_MEMORY_DIST_SESSION_MAX: {
    name: 'browser.memory.dist.session_max',
    hash: 'c61522ce6a8197750684b38d43bd495f8c8208ff945f274743711f47f577079a',
    type: 'distribution',
  },
  BROWSER_REACT_PROFILER_APP_ACTUAL_DURATION: {
    name: 'browser.react.profiler.app.actual_duration',
    hash: '0c82ee3933bf3b484f6aaa3e9ff4b53c7281e23747d3aa23d1c2967073dc989a',
    type: 'distribution',
  },
  BROWSER_REACT_PROFILER_APP_BASE_DURATION: {
    name: 'browser.react.profiler.app.base_duration',
    hash: '71c768070b707947eebff7086f64b92d0a07dc4149e7d4e05a0641c4dad6bb63',
    type: 'distribution',
  },
  BROWSER_REACT_PROFILER_APP_COMMIT_LAG: {
    name: 'browser.react.profiler.app.commit_lag',
    hash: '1640ce88b596f4bd472a0920aab28fc3a19fa159ce73e24d85749412068c8057',
    type: 'distribution',
  },
  BROWSER_REACT_PROFILER_ROUTE_ACTUAL_DURATION: {
    name: 'browser.react.profiler.route.actual_duration',
    hash: '20a2fd38da8dc5afa74167e694d394c91fbed208c2cf002872f11550cd35fbab',
    type: 'distribution',
  },
  BROWSER_REACT_PROFILER_ROUTE_BASE_DURATION: {
    name: 'browser.react.profiler.route.base_duration',
    hash: '1a0cc657855391adcd36b98829d0c83991b8eef57c93564bf9bf1a1ee0f7036c',
    type: 'distribution',
  },
  BROWSER_REACT_PROFILER_ROUTE_COMMIT_LAG: {
    name: 'browser.react.profiler.route.commit_lag',
    hash: '1bb160294f50714704b572b8cf928a2401845250032d0983d7938278f382737f',
    type: 'distribution',
  },
  BROWSER_REACT_HYDRATION_DURATION: {
    name: 'browser.react.hydration.duration',
    hash: '82c79908e1a129f357f84b61e17741c540b1b31979f0162318250ef2449646fe',
    type: 'distribution',
  },
  BROWSER_REACT_PROFILER_ROUTE_RENDER_EFFICIENCY: {
    name: 'browser.react.profiler.route.render_efficiency',
    hash: 'beef377799cdd79641899e0a78b2c5002494e02ebe125eb0c0d3920eb8623a1e',
    type: 'distribution',
  },
  BROWSER_REACT_PROFILER_APP_RENDER_EFFICIENCY: {
    name: 'browser.react.profiler.app.render_efficiency',
    hash: 'b22af24d9571ad02d8dc59c8778fee9505bcd909d5558dd5243521d2b4796a1d',
    type: 'distribution',
  },
  BROWSER_VITALS_DIST_INP_INPUT_DELAY: {
    name: 'browser.vitals.dist.inp.input_delay',
    hash: 'f8b3556c61cefdd20a76119f6d07eda34630fe54e3ba3f39606ace136d7e375e',
    type: 'distribution',
  },
  BROWSER_VITALS_DIST_INP_PROCESSING: {
    name: 'browser.vitals.dist.inp.processing',
    hash: '99440bcc187f689ff36aa9ec2e217ad70ee254143b467f4d156c241102d26b28',
    type: 'distribution',
  },
  BROWSER_VITALS_DIST_INP_PRESENTATION: {
    name: 'browser.vitals.dist.inp.presentation',
    hash: '5cae05a9e69973623a8cfd82f64689b017be8c1d04c9bf873960767c246f1247',
    type: 'distribution',
  },
  ISSUES_SHOW_HPC: {
    name: 'issues.show.hpc',
    hash: 'c759e7a27c38442130f055911b544bce97789db5b8b390f57d35386f6f234b7f',
    type: 'distribution',
  },
  BROWSER_VITALS_SUPPRESSED: {
    name: 'browser.vitals.suppressed',
    hash: '537aa3499772d75ec67b59e3e5a6065af1212ecfe594c522939d0fa02147fb1b',
    type: 'count',
  },
  LANDING_PAGES_VITALS_HPC: {
    name: 'landing_pages.vitals.hpc',
    hash: '104639e052e30bca541c4acbc2374b70c80ab5de8571a20254a0f61e04180f11',
    type: 'distribution',
  },
  LANDING_PAGES_VITALS_CLS: {
    name: 'landing_pages.vitals.cls',
    hash: 'ee1b16995cee9f07c6cc0e26d6408cea02baface4b562d934394311ac22559cd',
    type: 'distribution',
  },
  LANDING_PAGES_VITALS_LCP: {
    name: 'landing_pages.vitals.lcp',
    hash: '24f158c0b36f58a0edcb60eab9b0477f3b635f67bd5202e65e80bb17982a8b00',
    type: 'distribution',
  },
  LANDING_PAGES_VITALS_INP: {
    name: 'landing_pages.vitals.inp',
    hash: '203b2f53cf07984b95d893c21fb643bff3e494eeec63360d9d4189340e7c5fd6',
    type: 'distribution',
  },
  TURBO_ERROR_RESPONSE_NOT_HTML: {
    name: 'turbo.error.response.not_html',
    hash: 'f1b17addcb274c9155f3bb858bfbc8a43e80f718ed0df653e355d0d57c188517',
    type: 'increment',
  },
  CODE_VIEW_REPO_OVERVIEW_HPC: {
    name: 'code-view.repo-overview.hpc',
    hash: 'cd3bc78d2aece4879ae103bd22362fd031ea7144e2658d3a5bc7f475819dfdea',
    type: 'distribution',
  },
  CODE_VIEW_TREE_HPC: {
    name: 'code-view.tree.hpc',
    hash: 'f22a7626ef638ad3492f13c84a79ae4fe199006ca0729b4d189e25a78c67b0f2',
    type: 'distribution',
  },
  CODE_VIEW_TREE_INP: {
    name: 'code_view.tree.inp',
    hash: 'bcb586ccdc889f22fa01ec8b6090373b03b39f1bea96a17f6684c6df573d3ebb',
    type: 'distribution',
  },
  CODE_VIEW_REPO_OVERVIEW_INP: {
    name: 'code_view.repo_overview.inp',
    hash: '677d3d81e569656264d5e628a09d0217bbc7652befb675bd11bbaf64e340e2c2',
    type: 'distribution',
  },
} as const satisfies Record<string, CustomMetric>

export type CustomMetricKey = keyof typeof CUSTOM_METRIC_REGISTRY
